var FormatFactory = require('../../../factory/formats');

module.exports = {
  eventCategory: 'Editor UI | Bottom Menu',
  eventAction: 'size',

  showResizeEvent: { eventLabel: 'display_resize_options' },
  showResizeMenu: { eventLabel: 'display_multi_resize_menu' },
  doResizeEvent: function (event) {
    var width, height, unit, sizes = '';
    var isCustomSize = this.$el.find('input.custom').is(':checked');

    if (isCustomSize) {
      width = parseFloat(this.$el.find('input.size.page-width').val());
      height = parseFloat(this.$el.find('input.size.page-height').val());
      unit = this.$el.find('select.unit').val();

      sizes = width + 'x' + height + unit;
    } else {
      this.$el.find('[type=checkbox]:checked').each(function (i, checkbox) {
        FormatFactory.getFormat($(checkbox).val()).then(_.bind(function (format) {
          sizes += format.width + 'x' + format.height + format.unit + ' ';
        }, this));
      });
    }

    this.trackEvent({
      eventAction: isCustomSize ? 'resize_custom' : 'resize_standar',
      eventLabel: 'from ' + this.$el.find('.page-size').text().trim() + ' to ' + sizes
    });
  }
};
